import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { AppIconsLogoSavio, AppIconsLogoVandewiele } from "../AppIcons";

export const Root = styled(Box, { label: "Authentication-root" })(
  ({ theme: Theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    height: '100%',
    fontFamily: Theme.typography.fontFamily,
    color: Theme.palette.primary.main,

  })
);


export const Point1 = styled("span", { label: "Authentication-spanPoint1" })(
  ({ theme: Theme }) => ({
    animationName: "points",
    animationDuration: '1s',
    animationIterationCount: 'infinite',
  })
);


export const Point2 = styled("span", { label: "Authentication-spanPoint2" })(
  ({ theme: Theme }) => ({
    animationName: "points",
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationDelay: '0.33s',
  })
);


export const Point3 = styled("span", { label: "Authentication-spanPoint3" })(
  ({ theme: Theme }) => ({
    animationName: "points",
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationDelay: '0.66s',
  })
);

export const Logo = styled(AppIconsLogoVandewiele, { label: "Authentication-logo" })(
  ({ theme: Theme }) => ({
    color: Theme.palette.primary.main,
    fontSize: 200,
    // marginTop: -180,
    position: "fixed",
    bottom:  -60
  })
);

export const Text = styled(Typography, { label: "Authentication-logo" })(
  ({ theme: Theme }) => ({
    // marginTop: -180,
    fontSize: 14,
  })
);